import { LinearProgress } from "@material-ui/core";
import axios from "axios";
import Moment from "moment";
import React, { Component } from "react";
import { Badge, Card, Modal, Table, Button, Alert } from "react-bootstrap";
import { Bar, Doughnut } from "react-chartjs-2";
import { NavLink } from "react-router-dom";
import { toAbsoluteUrl } from "../../../_metronic/_helpers";
import { Tooltip } from "@material-ui/core";
import swal from "sweetalert";
import {
  CardBody,
  NoticeDashboard,
  NoticeInformasi,
} from "../../../_metronic/_partials/controls";
import AppConfig from "../../config/AppConfig";
import BarChartPresentase from "./component/detail-kebijakan/components/telah-mengisi/BarChartPresentase";
import BarChartVerifikasi from "./component/detail-kebijakan/components/telah-mengisi/BarChartVerifikasi";
import InformasiDasar from "./component/InformasiDasar/InformasiDasar";
import SebaranAkreditasi from "./component/SebaranAkreditasi/SebaranAkreditasi";
import SebaranPelaporan from "./component/SebaranPelaporan/SebaranPelaporan";
import SebaranSPMI from "./component/SebaranSPMI/SebaranSPMI";

const bgImage = toAbsoluteUrl("/media/bg/bg-5.jpg");
class SPMI extends Component {
  constructor(props) {
    super(props);
    this.modalDetail = this.modalDetail.bind(this);
    this.handleClose = this.handleClose.bind(this);
    this.handleCloseSurvei = this.handleCloseSurvei.bind(this);
    this.submitSurvei = this.submitSurvei.bind(this);
    this.lihatSurvei = this.lihatSurvei.bind(this);
    this.deleteSurvei = this.deleteSurvei.bind(this);

    this.state = {
      // information data(s)
      keyword: "",
      limit: 4,
      start: 0,
      loadingList: true,
      data_konten: [],
      data_foto: [],
      data_lampiran: [],
      totalData: 0,
      totalPaginationNumber: 0,
      showFrom: 0,
      modalDetail: false,
      loadingDetails: true,
      // survei
      showSurvei: false,
      pernyataan: [],
      hasil_survei: [],
      id_survei_kepuasan_saran: "",
      saran: "",
      loadingSaveSurvei: false,
      btn_hapus: false,
      info_survei: false,
      survei_disable: false,
      // ====
      detail_informasi: [],
      detail_cover: null,
      file: "",
      nm_file: "",
      // ============================
      displaydosen: false,
      displayprodi: false,
      dosendata: undefined,
      prodidata: undefined,
      key: "1",
      series: [
        {
          name: "Desktops",
          data: [10, 41, 35, 51, 49, 62, 69, 91, 148],
        },
      ],
      ///////
      labels1: [
        "PT yang telah mengisi bagian aspek pengaturan",
        "PT yang tidak mengisi bagian aspek pengaturan",
      ],
      datasets1: [
        {
          data: [0, 0],
          dataPoints: [
            { label: "A", y: 71 },
            { label: "B", y: 55 },
            { label: "C", y: 50 },
            { label: "D", y: 65 },
          ],
          backgroundColor: ["#A8E7E9", "#FFEF78"],
          hoverOffset: 4,
        },
      ],
      labels2: [
        "PT yang telah melengkapi bagian aspek pengaturan",
        "PT yang memiliki bagian aspek pengaturan",
      ],
      datasets2: [
        {
          data: [0, 0],
          dataPoints: [
            { label: "A", y: 71 },
            { label: "B", y: 55 },
            { label: "C", y: 50 },
            { label: "D", y: 65 },
          ],
          backgroundColor: ["#A8E7E9", "#FFEF78"],
          hoverOffset: 4,
        },
      ],
      labels3: ["1/6", "2/6", "3/6", "4/6", "5/6", "6/6"],
      datasets3: [
        {
          data: [10, 5, 10, 3, 5, 8],
          dataPoints: [
            { label: "A", y: 71 },
            { label: "B", y: 55 },
            { label: "C", y: 50 },
            { label: "D", y: 65 },
            { label: "B", y: 55 },
            { label: "C", y: 50 },
          ],
          backgroundColor: [
            "#A8E7E9",
            "#FFEF78",
            "#FAEBA6",
            "#DCE2E2",
            "#B5EECD",
            "#FCDCA9",
          ],
          hoverOffset: 4,
        },
      ],
    };
  }
  dataline = {
    labels: ["loading ..", "loading .."],
    datasets: [
      {
        label: "Jumlah pengaturan",
        data: [0, 0],
        fill: true,
        backgroundColor: ["#8f9491", "#e0e0e0"],
        borderColor: "rgb(117,117,117)",
      },
    ],
  };
  options = {
    scales: {
      yAxes: [
        {
          ticks: {
            beginAtZero: true,
            userCallback: function(label, index, labels) {
              // when the floored value is the same as the value we have a whole number
              if (Math.floor(label) === label) {
                return label;
              }
            },
          },
        },
      ],
    },
  };

  state = {
    total_pt: 0,
  };

  dataJumMengisiPengaturan = {
    labels: ["Jumlah Pengaturan"],
    datasets: [
      {
        label: "PTS",
        fill: false,
        lineTension: 0.1,
        backgroundColor: "#4472C4",
        borderColor: "#4472C4",
        borderCapStyle: "butt",
        borderDash: [],
        borderDashOffset: 0.0,
        borderJoinStyle: "miter",
        pointBorderColor: "#4472C4",
        pointBackgroundColor: "#4472C4",
        pointBorderWidth: 1,
        pointHoverRadius: 5,
        pointHoverBackgroundColor: "#4472C4",
        pointHoverBorderColor: "#4472C4",
        pointHoverBorderWidth: 2,
        pointRadius: 1,
        pointHitRadius: 10,
        data: [7891],
      },
      {
        label: "PTN",
        fill: false,
        lineTension: 0.1,
        backgroundColor: "#ED7D39",
        borderColor: "#ED7D39",
        borderCapStyle: "butt",
        borderDash: [],
        borderDashOffset: 0.0,
        borderJoinStyle: "miter",
        pointBorderColor: "#ED7D39",
        pointBackgroundColor: "#ED7D39",
        pointBorderWidth: 1,
        pointHoverRadius: 5,
        pointHoverBackgroundColor: "#ED7D39",
        pointHoverBorderColor: "#ED7D39",
        pointHoverBorderWidth: 2,
        pointRadius: 1,
        pointHitRadius: 10,
        data: [5987],
      },
    ],
  };

  options2 = {
    indexAxis: "y",
    scales: {
      yAxes: [
        {
          ticks: {
            beginAtZero: true,
            userCallback: function(label, index, labels) {
              // when the floored value is the same as the value we have a whole number
              if (Math.floor(label) === label) {
                return label;
              }
            },
          },
        },
      ],
    },
    plugins: {
      legend: {
        display: true,
        position: "bottom",
      },
    },
  };

  componentDidMount() {
    this.getinformations();
    this.getSurveiKepuasan();

    let userdata = JSON.parse(localStorage.getItem("userdata"));
    let sessiondata = JSON.parse(localStorage.getItem("sessiondata"));

    let session = "";
    if (userdata) {
      session =
        // "?token="+userdata.token+
        "?id_pengguna=" +
        userdata.id_pengguna +
        "&id_unit=" +
        sessiondata.i_idunit +
        "&id_role=" +
        sessiondata.i_idrole;
    }
    axios
      .get(AppConfig.urlAPiGetDashboard + session)
      .then((res) => {
        let nw1 = [
          {
            data: [res.data.result.ptmengisi, res.data.result.pttidakmengisi],
            backgroundColor: ["#79B4B7", "#FFB344"],
          },
        ];
        let nw2 = [
          {
            data: [
              res.data.result.ptpunyapengaturan,
              res.data.result.pttidakpunyapengaturan,
            ],
            backgroundColor: ["#79B4B7", "#FFB344"],
          },
        ];
        console.log(res.data.result.presentasepengaturan.p17);
        console.log("res.data.result.p17");
        let nw3 = [
          {
            data: [
              res.data?.result?.presentasepengaturan?.p17,
              res.data?.result?.presentasepengaturan?.p33,
              res.data?.result?.presentasepengaturan?.p50,
              res.data?.result?.presentasepengaturan?.p67,
              res.data?.result?.presentasepengaturan?.p83,
              res.data?.result?.presentasepengaturan?.p100,
            ],
            backgroundColor: [
              "#A8E7E9",
              "#FFEF78",
              "#FAEBA6",
              "#DCE2E2",
              "#B5EECD",
              "#FCDCA9",
            ],
          },
        ];

        this.dataline = {
          labels: res.data.result.tahun,
          datasets: [
            {
              label: "Jumlah pengaturan",
              data: res.data.result.jum,
              fill: true,
              backgroundColor: "#5C7AEA",
              borderColor: "#5C7AEA",
            },
          ],
        };

        this.setState({
          datasets1: nw1,
          datasets2: nw2,
          datasets3: nw3,
          total_pt: res.data?.result?.ptdikbud,
        });
      })
      .catch((err) => {
        console.log(err);
      });
  }

  getinformations() {
    console.log(this.state);
    this.setState({ loadingList: true });

    let sessiondata = JSON.parse(localStorage.getItem("sessiondata"));

    var formData = new FormData();
    formData.append("data[keyword]", this.state.keyword);
    formData.append("data[id_viewer]", sessiondata.i_idrole);
    formData.append("data[id_pembina]", sessiondata.i_idunit);
    axios
      .post(
        AppConfig.ListKonten +
          "?limit=" +
          this.state.limit +
          "&start=" +
          this.state.start,
        formData
      )
      .then((res) => {
        console.log(res);
        this.setState(
          {
            loadingList: false,
            data_konten: res.data?.result?.data,
            data_foto: res.data?.result?.pict_cover,
            totalData: res.data?.result?.total_rows,
            totalPaginationNumber: Math.ceil(
              res.data.result.total_rows / this.state.limit
            ),
            showFrom: (this.state.currentPage - 1) * this.state.limit + 1,
          },
          () => {
            // console.log(this.state.getUsers);
          }
        );
      })
      .catch((err) => {
        console.log(err);
      });
  }

  onChangeSurvei = (e) => {
    let change_survei = this.state.pernyataan.map((val) => {
      if (val.id_pernyataan === e.target.name) {
        val.tingkat_kepuasan = parseInt(e.target.value);
      }
      return val;
    });
    this.setState({ pernyataan: change_survei });
  };

  lihatSurvei() {
    this.setState({
      showSurvei: true,
    });
  }

  getSurveiKepuasan() {
    let userdata = JSON.parse(localStorage.getItem("userdata"));
    let sessiondata = JSON.parse(localStorage.getItem("sessiondata"));
    let session = "";
    if (userdata) {
      session =
        // "?token="+userdata.token+
        "?id_pengguna=" +
        userdata.id_pengguna +
        "&id_unit=" +
        sessiondata.i_idunit +
        "&id_role=" +
        sessiondata.i_idrole;
    }

    this.setState({ loadingList: true });

    var formData = new FormData();
    formData.append("data[id_role]", sessiondata.i_idrole);
    formData.append("data[id_sp]", sessiondata.i_idunit);
    formData.append("data[id_pengguna]", sessiondata.i_iduser);
    axios
      .post(AppConfig.DataSurveiKepuasan + session, formData)
      .then((res) => {
        let data_pernyataan = [];
        let jum_jawaban = 0;
        let survei_disable = false;
        for (let i = 0; i < res.data?.result?.pernyataan?.length; i++) {
          const val = res.data?.result?.pernyataan[i];
          let tingkat_kepuasan = "";
          let id_survei_kepuasan = "";
          if (res.data?.result?.hasil_survei[val.id_pernyataan] !== undefined) {
            tingkat_kepuasan =
              res.data?.result?.hasil_survei[val.id_pernyataan]?.tingkat_kepuasan;
            id_survei_kepuasan =
              res.data?.result?.hasil_survei[val.id_pernyataan]
                .id_survei_kepuasan;
            if (
              res.data?.result?.hasil_survei[val.id_pernyataan]
                .tingkat_kepuasan !== "null"
            ) {
              jum_jawaban += 1;
            }
            if (
              res.data?.result?.hasil_survei[val.id_pernyataan]?.id_pengguna !==
              userdata.id_pengguna
            ) {
              survei_disable = true;
            }
          }

          if (res.data?.result?.hasil_survei["null"] !== undefined) {
            this.setState({
              id_survei_kepuasan_saran:
                res.data?.result.hasil_survei["null"]?.id_survei_kepuasan,
              saran: res.data?.result?.hasil_survei["null"]?.saran,
            });
          }

          let data_p = {
            id_pernyataan: val.id_pernyataan,
            pernyataan: val.pernyataan,
            tingkat_kepuasan: tingkat_kepuasan,
            id_survei_kepuasan: id_survei_kepuasan,
            saran: "",
          };
          data_pernyataan.push(data_p);
        }

        let statusSurvei = false;
        if (
          res.data?.result?.pernyataan?.length > 0 &&
          jum_jawaban < res.data?.result?.pernyataan?.length
        ) {
          statusSurvei = true;
        } else {
          if (res.data?.result?.pernyataan?.length > 0) {
            this.setState({
              info_survei: true,
            });
          }
        }

        let statusBtnHapus = false;
        if (Object.keys(res.data?.result?.hasil_survei)?.length > 0) {
          statusBtnHapus = true;
        }
        this.setState({
          showSurvei: statusSurvei,
          pernyataan: data_pernyataan,
          btn_hapus: statusBtnHapus,
          survei_disable: survei_disable,
        });
      })
      .catch((err) => {
        console.log(err);
      });
  }

  submitSurvei() {
    this.setState({ loadingSaveSurvei: true });

    let userdata = JSON.parse(localStorage.getItem("userdata"));
    let sessiondata = JSON.parse(localStorage.getItem("sessiondata"));
    let session = "";
    if (userdata) {
      session =
        // "?token="+userdata.token+
        "?id_pengguna=" +
        userdata.id_pengguna +
        "&id_unit=" +
        sessiondata.i_idunit +
        "&id_role=" +
        sessiondata.i_idrole;
    }

    let pernyataan_save = [];
    for (let i = 0; i < this.state.pernyataan.length; i++) {
      const val = this.state.pernyataan[i];

      let data_p = {
        id_pernyataan: val.id_pernyataan,
        pernyataan: val.pernyataan,
        tingkat_kepuasan: val.tingkat_kepuasan.toString(),
        id_survei_kepuasan: val.id_survei_kepuasan,
        saran: val.saran,
      };

      pernyataan_save.push(data_p);
    }
    if (this.state.saran !== "") {
      let data_p = {
        id_pernyataan: "",
        pernyataan: "",
        tingkat_kepuasan: "",
        id_survei_kepuasan: this.state.id_survei_kepuasan_saran,
        saran: this.state.saran,
      };
      pernyataan_save.push(data_p);
    }

    var formData = new FormData();
    formData.append("data[id_role]", sessiondata.i_idrole);
    formData.append("data[id_sp]", sessiondata.i_idunit);
    formData.append("data[id_pengguna]", sessiondata.i_iduser);
    formData.append("data[data_survei]", JSON.stringify(pernyataan_save));

    console.log("formData", formData);
    axios
      .post(AppConfig.SaveDataSurveiKepuasan + session, formData)
      .then((res) => {
        this.setState({
          loadingSaveSurvei: false,
        });
        if (res.data.status === "sukses") {
          swal({
            title: "Berhasil!",
            text: "Simpan survei kepuasan pengguna berhasil!",
            icon: "success",
            button: "OK!",
          });
          this.componentDidMount();
        } else {
          swal({
            title: "Gagal!",
            text: "Simpan survei kepuasan pengguna gagal!",
            icon: "error",
            button: "OK!",
          });
        }
      })
      .catch((err) => {
        console.log(err);
      });
  }

  deleteSurvei() {
    let userdata = JSON.parse(localStorage.getItem("userdata"));
    let sessiondata = JSON.parse(localStorage.getItem("sessiondata"));
    let session = "";
    if (userdata) {
      session =
        // "?token="+userdata.token+
        "?id_pengguna=" +
        userdata.id_pengguna +
        "&id_unit=" +
        sessiondata.i_idunit +
        "&id_role=" +
        sessiondata.i_idrole;
    }

    swal({
      title: "Apakah anda yakin?",
      text: "Data akan terhapus dan tidak tercatat pada historical",
      icon: "warning",
      buttons: true,
      dangerMode: false,
    }).then((willDelete) => {
      if (willDelete) {
        this.setState({ loadingSaveSurvei: true });

        var formData = new FormData();
        formData.append("data[id_role]", sessiondata.i_idrole);
        formData.append("data[id_sp]", sessiondata.i_idunit);
        formData.append("data[id_pengguna]", sessiondata.i_iduser);

        axios
          .post(AppConfig.DeleteDataSurveiKepuasan + session, formData)
          .then((res) => {
            this.setState({
              loadingSaveSurvei: false,
            });
            if (res.data.status === "sukses") {
              this.setState({
                btn_hapus: false,
                info_survei: false,
                saran: "",
                id_survei_kepuasan_saran: "",
              });
              swal({
                title: "Berhasil!",
                text: "Hapus survei kepuasan pengguna berhasil!",
                icon: "success",
                button: "OK!",
              });
              this.componentDidMount();
            } else {
              swal({
                title: "Gagal!",
                text: "Hapus survei kepuasan pengguna gagal!",
                icon: "error",
                button: "OK!",
              });
            }
          })
          .catch((err) => {
            console.log(err);
          });
      }
    });
  }

  modalDetail(id, cover) {
    this.setState({ modalDetail: true, loadingDetails: true, detail_cover: cover });
    axios
      .get(AppConfig.EditInformasi + id)
      .then((res) => {
        this.setState({
          loadingDetails: false,
          detail_informasi: {
            judul: res.data.result.data_konten.judul,
            isi_konten: res.data.result.data_konten.isi_konten,
          },
          file: res.data.result.data_lampiran?.konten_dokumen,
          nm_file: res.data.result.data_lampiran?.filename,
        });
      })
      .catch((err) => {
        console.log(err);
      });
  }

  handleClose() {
    this.setState({
      modalDetail: false,
      detail_cover: null,
    });
  }

  handleCloseSurvei() {
    this.setState({
      showSurvei: false,
    });
  }

  onChangeVal = (e, type) => {
    this.setState({
      [type]: e.target.value,
      counter: e.target.value.length,
    });
  };

  downloadPDF(file) {
    const linkSource = `data:application/pdf;base64,${file}`;
    const downloadLink = document.createElement("a");
    const fileName = this.state.nm_file;

    downloadLink.href = linkSource;
    downloadLink.download = fileName;
    downloadLink.click();
  }

  render() {
    let userdata = JSON.parse(localStorage.getItem("sessiondata"));
    let sessiondata = JSON.parse(localStorage.getItem("sessiondata"));

    let id_pembina = sessiondata.i_idunit;
    let arrOfKonten = [];
    let coverPict = [];
    for (let i = 0; i < this.state.data_konten.length; i++) {
      const el = this.state.data_konten[i];
      if (el.id_role_updater === 10) {
        arrOfKonten.push(el);
        coverPict.push(this.state.data_foto[i]);
      }
      if (el.id_role_updater === 2014) {
        if (el.id_pembina === id_pembina) {
          arrOfKonten.push(el);
          coverPict.push(this.state.data_foto[i]);
        }
      }
    }

    let data_survei = [];
    let body_btn_hapus = "";
    if (this.state.showSurvei === true) {
      this.state.pernyataan.map((list, i) => {
        data_survei.push(
          <tr>
            <td>{list.pernyataan}</td>
            <td style={{ textAlign: "center" }}>
              <input
                type="radio"
                name={list.id_pernyataan}
                disabled={this.state.survei_disable}
                value="1"
                onChange={this.onChangeSurvei}
                checked={list.tingkat_kepuasan === 1}
              />
            </td>
            <td style={{ textAlign: "center" }}>
              <input
                type="radio"
                name={list.id_pernyataan}
                disabled={this.state.survei_disable}
                value="2"
                onChange={this.onChangeSurvei}
                checked={list.tingkat_kepuasan === 2}
              />
            </td>
            <td style={{ textAlign: "center" }}>
              <input
                type="radio"
                name={list.id_pernyataan}
                disabled={this.state.survei_disable}
                value="3"
                onChange={this.onChangeSurvei}
                checked={list.tingkat_kepuasan === 3}
              />
            </td>
            <td style={{ textAlign: "center" }}>
              <input
                type="radio"
                name={list.id_pernyataan}
                disabled={this.state.survei_disable}
                value="4"
                onChange={this.onChangeSurvei}
                checked={list.tingkat_kepuasan === 4}
              />
            </td>
          </tr>
        );
      });

      if (this.state.btn_hapus === true && this.state.survei_disable === false) {
        body_btn_hapus = (
          <Button
            disabled={this.state.loadingSaveSurvei}
            onClick={this.deleteSurvei}
            variant="danger"
            className="mr-2"
          >
            Hapus
            {this.state.loadingSaveSurvei && (
              <i className="ml-3 spinner spinner-white"></i>
            )}
            &nbsp;&nbsp;
          </Button>
        );
      }
    }

    let info_survei = "";
    if (this.state.info_survei === true) {
      info_survei = (
        <Alert variant="info">
          <b>
            Anda telah mengisi survei kepuasan pengguna aplikasi pelaporan SPMI
            (spmi.kemdikbud.go.id).
            <a
              href="#"
              onClick={this.lihatSurvei}
              className="btn btn-primary ml-2"
            >
              Lihat Disini
            </a>
          </b>
        </Alert>
      );
    }

    return (
      <>
        <style>{`
          .card-informasi {
            cursor: pointer;
            transition: transform 0.25s ease, box-shadow 0.25s ease;
          }
          .card-informasi:hover {
            transform: translateY(-6px);
            box-shadow: 0 12px 24px rgba(0,0,0,0.12) !important;
          }
        `}</style>
        <NoticeDashboard
          className="bg-primary"
          style={{ boxShadow: "none", backgroundImage: `url(${bgImage})` }}
        >
          <strong className=" text-white" style={{ fontSize: "18px" }}>
            DASHBOARD
          </strong>
          <p className=" text-white">
            Pemantauan Perguruan Tinggi Yang Telah/Tidak Mengisi Aspek
            Pengaturan Kebijakan SPMI
          </p>
        </NoticeDashboard>
        {info_survei}
        <div className="row row-paddingless">
          <div
            className="col-md-12"
            style={{ paddingBottom: "3%", textAlign: "center" }}
          >
            <Card>
              <CardBody>
                <h5
                  className="card-title font-weight-bolder "
                  style={{ color: "#354f7a" }}
                >
                  Jumlah Pengaturan Berdasarkan Tahun Penetapan
                </h5>
                <Bar data={this.dataline} options={this.options} height={100} />
              </CardBody>
            </Card>
          </div>
        </div>
        <div className="row row-paddingless">
          <div className="col-md-6 col-xxl-6">
            {userdata.i_idrole === "1" ||
            userdata.i_idrole === 1 ||
            userdata.i_idrole === "10" ||
            userdata.i_idrole === 10 ? (
              <BarChartPresentase />
            ) : (
              ""
            )}
          </div>
          <div className="col-md-6 col-xxl-6" style={{ marginBottom: "10px" }}>
            {userdata.i_idrole === "1" ||
            userdata.i_idrole === 1 ||
            userdata.i_idrole === "10" ||
            userdata.i_idrole === 10 ? (
              <BarChartVerifikasi />
            ) : (
              ""
            )}
          </div>
          <div className="col-md-4" style={{ textAlign: "center" }}>
            <Card style={{ padding: "5%" }}>
              <br />
              <h5
                className="card-title font-weight-bolder "
                style={{ color: "#354f7a", paddingRight: "1.5%" }}
              >
                Perguruan Tinggi Yang Telah Mengisi Aspek Pengaturan Kebijakan
                SPMI
              </h5>
              {/* <Pie 
                                data={{
                                labels: this.state.labels1, 
                                datasets: this.state.datasets1}}/> */}
              <Doughnut
                data={{
                  labels: this.state.labels1,
                  datasets: this.state.datasets1,
                }}
                options={{
                  responsive: true,
                  maintainAspectRatio: true,
                  legend: { display: true },
                  elements: {
                    center: {
                      color: "#1f4e56", // Default is #000000
                      fontStyle: "Arial", // Default is Arial
                      // sidePadding: 20, // Default is 20 (as a percentage)
                      // minFontSize: 19, // Default is 20 (in px), set to false and text will not wrap.
                      // lineHeight: 30 // Default is 25 (in px), used for when text wraps
                    },
                  },
                }}
              />
              <br />
              {userdata.i_idrole === "3" ||
              userdata.i_idrole === 3 ||
              userdata.i_idrole === "6" ||
              userdata.i_idrole === 6 ? (
                ""
              ) : (
                <a href="/mengisi">
                  <button className="btn btn-primary">
                    <i className="fa fa-eye" /> Detail
                  </button>
                </a>
              )}
            </Card>
          </div>

          <div
            className="col-md-4"
            style={{ textAlign: "center", paddingLeft: "1.5%" }}
          >
            <Card style={{ padding: "5%" }}>
              <br />
              <h5
                className="card-title font-weight-bolder "
                style={{ color: "#354f7a", paddingRight: "1.5%" }}
              >
                Kelengkapan pengisian Pengaturan SPMI
              </h5>
              {/* <Pie 
                                data={{
                                labels: this.state.labels1, 
                                datasets: this.state.datasets1}}/> */}
              <Doughnut
                data={{
                  labels: this.state.labels3,
                  datasets: this.state.datasets3,
                }}
                options={{
                  responsive: true,
                  maintainAspectRatio: true,
                  legend: { display: true },
                  elements: {
                    center: {
                      color: "#1f4e56", // Default is #000000
                      fontStyle: "Arial", // Default is Arial
                      // sidePadding: 20, // Default is 20 (as a percentage)
                      // minFontSize: 19, // Default is 20 (in px), set to false and text will not wrap.
                      // lineHeight: 30 // Default is 25 (in px), used for when text wraps
                    },
                  },
                }}
              />
              <br />
              {userdata.i_idrole === "3" ||
              userdata.i_idrole === 3 ||
              userdata.i_idrole === "6" ||
              userdata.i_idrole === 6 ? (
                ""
              ) : (
                <a href="/kelengkapan-mengisi">
                  <button className="btn btn-primary">
                    <i className="fa fa-eye" /> Detail
                  </button>
                </a>
              )}
            </Card>
          </div>
          <div
            className="col-md-4"
            style={{ textAlign: "center", paddingLeft: "1.5%" }}
          >
            <Card style={{ padding: "5%" }}>
              <br />
              <h5
                className="card-title font-weight-bolder "
                style={{ color: "#354f7a", paddingRight: "1.5%" }}
              >
                Perguruan Tinggi Yang Memiliki Pengaturan Kebijakan SPMI Secara
                Lengkap
              </h5>
              <Badge
                variant="light"
                style={{ fontSize: "12px", color: "#4d4d4d" }}
              >
                Jumlah Perguruan Tinggi : <strong>{this.state.total_pt}</strong>
              </Badge>
              {/* <Pie
                          data={{
                            labels: this.state.labels2, 
                            datasets: this.state.datasets2
                          }}
                        /> */}
              <Doughnut
                data={{
                  labels: this.state.labels2,
                  datasets: this.state.datasets2,
                }}
                options={{
                  legend: { display: true },
                  elements: {
                    center: {
                      color: "#1f4e56", // Default is #000000
                      fontStyle: "Arial", // Default is Arial
                      // sidePadding: 20, // Default is 20 (as a percentage)
                      // minFontSize: 19, // Default is 20 (in px), set to false and text will not wrap.
                      // lineHeight: 30 // Default is 25 (in px), used for when text wraps
                    },
                  },
                }}
              />
              <br />
              {userdata.i_idrole === "3" ||
              userdata.i_idrole === 3 ||
              userdata.i_idrole === "6" ||
              userdata.i_idrole === 6 ? (
                ""
              ) : (
                <a href="/mengisilengkap">
                  <button className="btn btn-primary">
                    <i className="fa fa-eye" /> Detail
                  </button>
                </a>
              )}
              <br />
            </Card>
          </div>
        </div>
        {userdata.i_idbp === 2 || userdata.i_idrole === 10 ? (
          <>
            <InformasiDasar />
            <SebaranPelaporan />
            <SebaranSPMI />
            <SebaranAkreditasi />
            {/* <TracerStudy /> */}
          </>
        ) : (
          ""
        )}

        <div className="row">
          <div
            className="col-md-6"
            style={{ paddingTop: "30px", textAlign: "center" }}
          >
            <Card>
              <CardBody>
                <h5
                  className="card-title font-weight-bolder mt-5"
                  style={{ color: "#354f7a" }}
                >
                  Grafik PTN dan PTS yang telah mengisi pengaturan SPMI
                </h5>
                <Bar
                  data={this.dataJumMengisiPengaturan}
                  options={this.options2}
                />
              </CardBody>
            </Card>
          </div>
        </div>

        <Card className="mt-20">
          {/* <CardContent> */}
          {/* begin: Head */}
          <NoticeInformasi style={{ marginBottom: "0px", boxShadow: "none" }}>
            <strong style={{ fontSize: "18px" }}>Papan Informasi</strong>
            <br />
            <NavLink to="/informasi">
              <span className="text-dark">Selengkapnya..</span>
            </NavLink>
          </NoticeInformasi>
          {/* end: Head */}

          <div className="row mt-4 px-5">
            {this.state.loadingList === true ? (
              <div className="col-12">
                <Card>
                  <Card.Body>
                    <LinearProgress color="secondary" variant="query" />
                  </Card.Body>
                </Card>
              </div>
            ) : arrOfKonten.length > 0 ? (
              arrOfKonten.map((data, idx) => (
                <div
                  key={data.id_konten}
                  className="col-sm-6 col-md-4 col-lg-3 mb-4"
                >
                  <Card
                    className="h-100 shadow-sm card-informasi"
                    onClick={() => this.modalDetail(data.id_konten, coverPict[idx])}
                  >
                    <div
                      style={{
                        height: "200px",
                        overflow: "hidden",
                        backgroundColor: "#f8f9fa",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                      }}
                    >
                      {coverPict[idx] ? (
                        <Card.Img
                          variant="top"
                          src={`data:image/jpeg;base64,${coverPict[idx]}`}
                          style={{
                            width: "100%",
                            height: "100%",
                            objectFit: "cover",
                          }}
                        />
                      ) : (
                        <img
                          src="media\\logos\\logo-letter-2.png"
                          alt="placeholder"
                          style={{
                            maxHeight: "120px",
                            maxWidth: "120px",
                            opacity: 0.5,
                          }}
                        />
                      )}
                    </div>
                    <Card.Body className="d-flex flex-column">
                      <Card.Title
                        className="font-weight-bold text-dark"
                        style={{
                          fontSize: "1rem",
                          display: "-webkit-box",
                          WebkitLineClamp: 2,
                          WebkitBoxOrient: "vertical",
                          overflow: "hidden",
                        }}
                      >
                        {data.judul}
                      </Card.Title>
                      <Card.Text
                        className="text-dark-50"
                        style={{
                          fontSize: "0.875rem",
                          display: "-webkit-box",
                          WebkitLineClamp: 3,
                          WebkitBoxOrient: "vertical",
                          overflow: "hidden",
                          flex: "1 0 auto",
                        }}
                      >
                        {data.deskripsi}
                      </Card.Text>
                      <div className="text-muted" style={{ fontSize: "0.8rem" }}>
                        <i className="flaticon-user mr-1" />
                        {data.nm_role_updater}
                        <br />
                        <i className="flaticon-calendar mr-1" />
                        {Moment(data.updated_at).format("DD-MMMM-YYYY")}
                      </div>
                    </Card.Body>
                  </Card>
                </div>
              ))
            ) : (
              <div className="col-12">
                <Card>
                  <Card.Body>
                    <em className="text-muted">Belum ada informasi tersedia</em>
                  </Card.Body>
                </Card>
              </div>
            )}
          </div>
          {/* </CardContent> */}
        </Card>

        {/*========================================== Begin Modal Detail ========================================== */}
        <Modal
          size="lg"
          show={this.state.modalDetail}
          onHide={this.handleClose}
          keyboard={true}
          centered
        >
          <Modal.Header>
            <Modal.Title>
              {this.state.loadingDetails
                ? "Memuat..."
                : this.state.detail_informasi.judul}
            </Modal.Title>
            <button
              type="button"
              className="close"
              onClick={this.handleClose}
              style={{ outline: "none" }}
            >
              <i className="flaticon2-cross" />
            </button>
          </Modal.Header>
          <Modal.Body>
            {this.state.loadingDetails === true ? (
              <LinearProgress color="secondary" variant="query" />
            ) : (
              <>
                {this.state.detail_cover && (
                  <div
                    className="text-center mb-4"
                    style={{
                      maxHeight: "300px",
                      overflow: "hidden",
                      borderRadius: "6px",
                      backgroundColor: "#f8f9fa",
                    }}
                  >
                    <img
                      src={`data:image/jpeg;base64,${this.state.detail_cover}`}
                      alt="cover"
                      style={{
                        width: "100%",
                        height: "auto",
                        maxHeight: "300px",
                        objectFit: "contain",
                      }}
                    />
                  </div>
                )}
                <div
                  className="text-justify"
                  style={{ lineHeight: 1.8 }}
                  dangerouslySetInnerHTML={{
                    __html: this.state.detail_informasi.isi_konten,
                  }}
                />
                <hr />
                <div>
                  <strong>Lampiran :</strong>{" "}
                  {this.state.nm_file === undefined ? (
                    <i style={{ fontSize: "13px" }}>Tidak ada lampiran</i>
                  ) : (
                    <a
                      href="#"
                      onClick={() => this.downloadPDF(this.state.file)}
                      style={{ fontWeight: 500 }}
                    >
                      <i className="flaticon2-pdf-file mr-1" />
                      {this.state.nm_file}
                    </a>
                  )}
                </div>
              </>
            )}
          </Modal.Body>
        </Modal>
        {/*========================================== End Modal Detail ========================================== */}
        <Modal size="xl" show={this.state.showSurvei}>
          <Modal.Header closeButton>
            <Modal.Title>
              Survei Kepuasan Pengguna Aplikasi Pelaporan SPMI
              (spmi.kemdikbud.go.id)
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Table responsive style={{ overflow: "auto" }}>
              <thead
                className="text-white"
                style={{ backgroundColor: "#3047ad" }}
              >
                <tr>
                  <th style={{ textAlign: "center", width: "50%" }} rowSpan={2}>
                    Pernyataan
                  </th>
                  <th style={{ textAlign: "center", width: "30%" }} colSpan={4}>
                    Tingkat Kepuasan
                  </th>
                </tr>
                <tr>
                  <th style={{ textAlign: "center" }}>
                    STS{" "}
                    <Tooltip title="Sangat Tidak Setuju" placement="top">
                      <i
                        style={{ fontSize: "15px" }}
                        className="text-white fa fa-info-circle"
                      ></i>
                    </Tooltip>
                  </th>
                  <th style={{ textAlign: "center" }}>
                    TS{" "}
                    <Tooltip title="Tidak Setuju" placement="top">
                      <i
                        style={{ fontSize: "15px" }}
                        className="text-white fa fa-info-circle"
                      ></i>
                    </Tooltip>
                  </th>
                  <th style={{ textAlign: "center" }}>
                    S{" "}
                    <Tooltip title="Setuju" placement="top">
                      <i
                        style={{ fontSize: "15px" }}
                        className="text-white fa fa-info-circle"
                      ></i>
                    </Tooltip>
                  </th>
                  <th style={{ textAlign: "center" }}>
                    SS{" "}
                    <Tooltip title="Sangat Setuju" placement="top">
                      <i
                        style={{ fontSize: "15px" }}
                        className="text-white fa fa-info-circle"
                      ></i>
                    </Tooltip>
                  </th>
                </tr>
              </thead>

              <tbody>{data_survei}</tbody>
            </Table>
            <p>Masukan dan Saran bagi pengembangan aplikasi pelaporan SPMI :</p>
            <textarea
              className="resize-none"
              style={{ padding: "12px", width: "100%" }}
              size="lg"
              rows="4"
              placeholder="Ketikan saran Anda disini..."
              name="saran"
              value={this.state.saran}
              onChange={(e) => this.onChangeVal(e, "saran")}
            ></textarea>
          </Modal.Body>
          <Modal.Footer>
            <div style={{ textAlign: "right" }}>
              {body_btn_hapus}
              {this.state.survei_disable === false ? (
                <Button
                  disabled={this.state.loadingSaveSurvei}
                  variant="primary"
                  onClick={this.submitSurvei}
                >
                  Submit
                  {this.state.loadingSaveSurvei && (
                    <i className="ml-3 spinner spinner-white"></i>
                  )}
                  &nbsp;&nbsp;
                </Button>
              ) : (
                ""
              )}
            </div>
            <Button variant="secondary" onClick={this.handleCloseSurvei}>
              Close
            </Button>
          </Modal.Footer>
        </Modal>
      </>
    );
  }
}
export default SPMI;
